import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Loader2, LogIn } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bentornato!");
      navigate("/");
    } else toast.error(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1464278533981-50106e6176b1?w=1600" alt="" className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-gradient-to-tr from-[#2C312E]/70 to-[#4A6B53]/30"/>
        <div className="relative h-full flex items-end p-12">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#E4B871] mb-3">Bentornato nel Network</div>
            <h2 className="font-display font-black text-4xl text-white leading-tight">
              Ritrova le tue<br/>fattorie preferite.
            </h2>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 md:p-14 bg-[#FBF9F6]">
        <form onSubmit={submit} className="w-full max-w-md">
          <h1 className="font-display font-black text-3xl md:text-4xl text-[#2C312E]">Accedi</h1>
          <p className="mt-2 text-[#58625B]">Entra per salvare i preferiti e gestire le tue richieste.</p>
          <div className="mt-8 space-y-4">
            <label className="block">
              <span className="text-xs font-bold uppercase tracking-wider text-[#7A7369]">Email</span>
              <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
                className="mt-2 w-full h-12 rounded-xl border-2 border-[#E5DCD0] bg-white px-4 focus:outline-none focus:ring-2 focus:ring-[#4A6B53] focus:border-transparent"
                data-testid="login-email"/>
            </label>
            <label className="block">
              <span className="text-xs font-bold uppercase tracking-wider text-[#7A7369]">Password</span>
              <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
                className="mt-2 w-full h-12 rounded-xl border-2 border-[#E5DCD0] bg-white px-4 focus:outline-none focus:ring-2 focus:ring-[#4A6B53] focus:border-transparent"
                data-testid="login-password"/>
            </label>
          </div>
          <button type="submit" disabled={loading} className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#4A6B53] text-white py-4 font-bold hover:bg-[#3D5844] disabled:opacity-60 transition-all" data-testid="login-submit">
            {loading ? <Loader2 size={18} className="animate-spin"/> : <LogIn size={16}/>} Accedi
          </button>
          <p className="mt-6 text-sm text-[#58625B] text-center">
            Non hai un account? <Link to="/register" className="font-bold text-[#C8795A] hover:underline">Registrati</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
